import React from 'react'
import PropTypes from 'prop-types'
import { AppointmentStatus, appointmentStatusMeta } from 'lib/constants'
require('./style.css')

const ColorCodeExplanation = ({ showCancelled }) => {
  const possibleStatus = [
    AppointmentStatus.Completed,
    AppointmentStatus.ReservedPaymentPending,
    AppointmentStatus.ReservedPaymentDone,
  ]
  possibleStatus.unshift(showCancelled ? (AppointmentStatus.CancelledByProfessional || AppointmentStatus.CancelledByClient || AppointmentStatus.CancelledByAdmin) : AppointmentStatus.Available)
  return (
    <div className="ColorCodeExplanation">
      <h5>Legenda das Consultas por Cor</h5>
      <div>
        {possibleStatus.map(status => (
          <ColorCodeLabel key={status} color={appointmentStatusMeta(status).color} status={appointmentStatusMeta(status).name} />
        ))}
      </div>
    </div>
  )
}

const ColorCodeLabel = ({ color, status }) => (
  <div className="ColorCodeLabel">
    <div style={{ backgroundColor: color }} />
    <span>{status}</span>
  </div>
)

ColorCodeExplanation.propTypes = {
  showCancelled: PropTypes.bool,
}

export default ColorCodeExplanation


// WEBPACK FOOTER //
// ./src/components/ColorCodeExplanation/index.js